import React, { FC, ReactElement, useState } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import CertificatesColumns from "../../models/ColumnDefinitions/CertificatesColumns";
import { ListData } from "../../models/ListData";
import { ListQuery } from "../../models/ListQuery";
import CertificatesSearch from "../../models/search/CertificatesSearch";
import { DeleteEntityResult } from "../../models/services/DeleteEntityResult";
import { TabSummary } from "../../models/TabSummary";
import { Lookup } from "../../models/Lookup";
import LookupTypes from "../../models/LookupTypes";
import { deleteCertificate, getCertificatesWithPagination } from "../../services/securityPolicyService";
import ActivityFrame from "../activity-frame/activity-frame";
import { CertificatesTab } from "../securityPoliciesTabs/CertificatesTab";
import Tabs from "../tabs/tabs";
import SiteSearch from "../../models/search/SiteSearch";
import { getSiteNamesWithPagination } from "../../services/siteService";

export const SecurityPolicyCertificates: FC = () => {
    const { translate } = useLocale();
    const [busy, setBusy] = useState<boolean>(false);
    const tabs: TabSummary[] = [
        { label: translate.byKey(TranslationKeys.all), badge: 0, showInitial: true, isActive: true }
    ];
    const [selectedTab, setSelectedTab] = useState(0);
    const [dataRefresh, setDataRefresh] = useState(() => (dataMethod?: (query?: ListQuery) => Promise<ListData>) => { return });
    const manualDataRefresh = (refreshData: (dataMethod?: (query?: ListQuery) => Promise<ListData>) => void) => {
        setDataRefresh(() => refreshData);
    }

    const lookup: Lookup[] = [{
        name: LookupTypes.site,
        values: [],
        dataMethod: getSiteNamesWithPagination,
        searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
    }];

    const onDeleteCertificate = async (id: string): Promise<DeleteEntityResult> => {
        setBusy(true);
        return new Promise((resolve, reject) => {
            deleteCertificate(id)
                .then(deleteResult => {
                    resolve(deleteResult);
                    setBusy(false);
                },
                deleteResult => {
                    reject(deleteResult);
                    setBusy(false);
                });
        });
    };

    const tabContent: ReactElement[] = [
        // All Certificates Tab
        <CertificatesTab
            key={'0'}
            title={translate.byKey(TranslationKeys.all)}
            dataMethod={(listParameters?: ListQuery) => getCertificatesWithPagination(translate, listParameters)}
            columns={CertificatesColumns}
            searchDescriptors={CertificatesSearch}
            refreshMethod={manualDataRefresh}
            lookup={lookup}
            getReportTitle={""}
            setBusy={setBusy}
            deleteMethod={onDeleteCertificate}
        />
    ];

    const onTabChange = (index: number) => {
        setSelectedTab(index);
    }

    return (
        <ActivityFrame busy={busy} className='flex flex-col flex-grow bg-white' >
            <div className="w-full overflow-hidden" >
                <Tabs
                    tabs={tabs}
                    onSelect={onTabChange}
                    selected={selectedTab}
                    add={false}
                    onAdd={() => { }}
                    isFlat={true}
                    className="w-full">
                    {tabContent[selectedTab]}
                </Tabs>
            </div>
        </ActivityFrame>
    );
};
